export const FAS = 'fasfinance-com'
export const SMT = 'sminti-eu'
export const POX = 'poxypay-com'
export const CAP = 'capecoins-com'
export const ARD = 'ardelero-com'
export const BQP = 'beeqeeper-com'
export const XPZ = 'expedez-com'
export const PLK = 'paylinka-pl'
export const TAP = 'tapank-com'
export const CLX = 'clarityx-eu'
export const ALT = 'altswapsro-com'
export const FTN = 'fintwinpay-com'
